<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-2">
<p class="subhead1c">FAMILY HISTORY FROM PEN &amp; SWORD BOOKS</p>
<p class="fm"><em class="italic">Birth, Marriage &amp; Death Records</em></p>
<p class="fm"><em class="italic">The Family History Web Directory</em></p>
<p class="fm"><em class="italic">Tracing British Battalions on the Somme</em></p>
<p class="fm"><em class="italic">Tracing Great War Ancestors</em></p>
<p class="fm"><em class="italic">Tracing History Through Title Deeds</em></p>
<p class="fm"><em class="italic">Tracing Secret Service Ancestors</em></p>
<p class="fm"><em class="italic">Tracing the Rifle Volunteers</em></p>
<p class="fm"><em class="italic">Tracing Your Air Force Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Ancestors from 1066 to 1837</em></p>
<p class="fm"><em class="italic">Tracing Your Ancestors Through Death Records – Second Edition</em></p>
<p class="fm"><em class="italic">Tracing Your Ancestors through Family Photographs</em></p>
<p class="fm"><em class="italic">Tracing Your Ancestors Through Letters and Personal Writings</em></p>
<p class="fm"><em class="italic">Tracing Your Ancestors Using DNA</em></p>
<p class="fm"><em class="italic">Tracing Your Ancestors Using the Census</em></p>
<p class="fm"><em class="italic">Tracing Your Ancestors: Cambridgeshire, Essex, Norfolk and Suffolk</em></p>
<p class="fm"><em class="italic">Tracing Your Aristocratic Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Army Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Army Ancestors – Third Edition</em></p>
<p class="fm"><em class="italic">Tracing Your Birmingham Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Black Country Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Boer War Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your British Indian Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Canal Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Channel Islands Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Church of England Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Criminal Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Docker Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your East Anglian Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your East End Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Family History on the Internet</em></p>
<p class="fm"><em class="italic">Tracing Your Female Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your First World War Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Freemason, Friendly Society and</em> <em class="italic">Trade Union Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Georgian Ancestors, 1714–1837</em></p>
<p class="fm"><em class="italic">Tracing Your Glasgow Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Great War Ancestors: The Gallipoli Campaign</em></p>
<p class="fm"><em class="italic">Tracing Your Great War Ancestors: The Somme</em></p>
<p class="fm"><em class="italic">Tracing Your Great War Ancestors: Ypres</em></p>
<p class="fm"><em class="italic">Tracing Your Huguenot Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Insolvent Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Irish Family History on the Internet</em></p>
<p class="fm"><em class="italic">Tracing Your Jewish Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Jewish Ancestors – Second Edition</em></p>
<p class="fm"><em class="italic">Tracing Your Labour Movement Ancestors</em>
</p>
<p class="fm"><em class="italic">Tracing Your Legal Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Liverpool Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Liverpool Ancestors – Second Edition</em></p>
<p class="fm"><em class="italic">Tracing Your London Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Medical Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Merchant Navy Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Northern Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Northern Irish Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Northern Irish Ancestors – Second</em> Edition</p>
<p class="fm"><em class="italic">Tracing Your Oxfordshire Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Pauper Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Police Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Potteries Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Pre-Victorian Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Prisoner of War Ancestors: The First</em> World War</p>
<p class="fm"><em class="italic">Tracing Your Railway Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Roman Catholic Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Royal Marine Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Rural Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Scottish Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Second World War Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Servant Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Service Women Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Shipbuilding Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Tank Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Textile Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Twentieth-Century Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Welsh Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your West Country Ancestors</em></p>
<p class="fm"><em class="italic">Tracing Your Yorkshire Ancestors Writing Your Family History</em></p>
<p class="fm"><em class="italic">Your Irish Ancestors</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002_About_the_author.vue?3310da0b